<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="true"
          >
            <template #head(articleNumber)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleNumber" />
            </template>
            <template #head(company)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.company" />
            </template>
            <template #head(matchcode)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.matchcode" />
            </template>
            <template #head(internalName)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.internalName" />
            </template>
            <template #head(articleMc1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleMc1" />
            </template>
            <template #head(articleMc3)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleMc3" />
            </template>
            <template #head(articleMc4)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleMc4" />
            </template>
            <template #head(articleMc5)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleMc5" />
            </template>
            <template #head(articleMc7)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleMc7" />
            </template>
            <template #head(vpQuantity)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.vpQuantity" />
            </template>
            <template #head(weight)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.weight" />
            </template>
            <template #head(evaluation1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.evaluation1" />
            </template>
            <template #head(evaluation2)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.evaluation2" />
            </template>
            <template #head(evaluation3)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.evaluation3" />
            </template>
            <template #head(evaluation4)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.evaluation4" />
            </template>
            <template #head(evaluation5)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.evaluation5" />
            </template>
            <template #head(evaluation6)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.evaluation6" />
            </template>
            <template #head(searchEnglish)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.searchEnglish" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';

const matchcodeArray = Array.from({ length: 14 }, (_, i) => i + 2);
const evaluationArray = Array.from({ length: 10 }, (_, i) => i + 1);

export default {
  name: 'Articles',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          {
            key: 'company',
            label: this.$translate('company'),
            thClass: 'article-number',
            tdClass: 'article-number',
            sortable: true,
          },
          {
            key: 'articleNumber',
            label: this.$translate('number_short'),
            thClass: 'article-number',
            tdClass: 'article-number',
            sortable: true,
          },
          {
            key: 'matchcode',
            label: this.$translate('matchcode'),
            thClass: 'matchcode',
            tdClass: 'matchcode',
            sortable: true,
          },
          {
            key: 'internalName',
            label: this.$translate('designation'),
            thClass: 'internal-name',
            tdClass: 'internal-name',
            sortable: true,
          },
          {
            key: 'articleMc1',
            label: this.$translate('article_mc_1'),
            thClass: 'article-matchcode',
            tdClass: 'article-matchcode',
            sortable: true,
          },
          {
            key: 'vpQuantity',
            label: this.$translate('vp_quantity'),
            thClass: ['vp-quantity', 'number-column'],
            tdClass: ['vp-quantity', 'number-column'],
            sortable: true,
          },
          {
            key: 'weight',
            label: this.$translate('weight'),
            thClass: ['weight', 'number-column'],
            tdClass: ['weight', 'number-column'],
            sortable: true,
          },
          {
            key: 'minPrice',
            label: this.$translate('minimum_sales_price'),
            thClass: ['minPrice', 'number-column'],
            tdClass: ['minPrice', 'number-column'],
            sortable: true,
          },
          ...evaluationArray.map((item) => ({
            key: `evaluation${item}`,
            label: `${this.$translate('evaluation')} ${item}`,
            thClass: 'evaluation',
            tdClass: 'evaluation',
            sortable: true,
          })),
          ...matchcodeArray.map((item) => ({
            key: `articleMc${item}`,
            label: `${this.$translate('article_mc')} ${item}`,
            thClass: 'article-matchcode',
            tdClass: 'article-matchcode',
            sortable: true,
          })),
          {
            key: 'searchEnglish',
            label: this.$translate('search_english'),
            thClass: ['searchEnglish', 'number-column'],
            tdClass: ['searchEnglish', 'number-column'],
            sortable: true,
          },
        ],
        filter: {
          articleNumber: null,
          company: null,
          matchcode: null,
          internalName: null,
          articleMc1: null,
          articleMc3: null,
          articleMc4: null,
          articleMc5: null,
          articleMc7: null,
          vpQuantity: null,
          weight: null,
          evaluation1: null,
          evaluation2: null,
          evaluation3: null,
          evaluation4: null,
          evaluation5: null,
          evaluation6: null,
          searchEnglish: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getPage(ctx);
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep   .b-table-sticky-header {
  max-height: calc(100vh - 230px);
  min-height: calc(100vh - 230px);
}

// @media (max-width: 991px) {
//   .main-content {
//     max-height: calc(100vh - 100px);
//   }
// }

::v-deep   .table {
  min-width: 1200px;
  overflow: scroll;
  td,
  th {
    word-break: break-word;
    &.vp-quantity,
    &.article-number {
      width: 150px;
    }

    &.weight {
      width: 100px;
    }

    &.matchcode {
      width: 150px;
    }

    &.minPrice {
      width: 150px;
    }
    &.searchEnglish {
      width: 150px;
    }

    &.internal-name {
      width: 200px;
      word-break: break-all;
    }

    &.article-matchcode {
      width: 170px;
      text-align: right;
    }

    &.evaluation {
      width: 150px;
      text-align: right;
    }
  }
}
</style>
